export function createEscapeKeyHandler(
  onClose: () => void,
): (event: KeyboardEvent) => void {
  return (event: KeyboardEvent): void => {
    if (event.key === "Escape") onClose();
  };
}

/**
 * Ctrl/Cmd/Shift/Altのいずれかが押されているかを判定する。
 * SPA内リンクのクリックハンドラでpreventDefault()する前に呼び出し、
 * 新規タブ/新規ウィンドウで開くブラウザ標準操作を横取りしないようにする。
 * @param event - ctrlKey/metaKey/shiftKey/altKeyを持つマウスイベント相当のオブジェクト
 * @returns 修飾キーのいずれかが押されていればtrue
 */
export function hasLinkModifierKey(event: {
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}): boolean {
  return event.ctrlKey || event.metaKey || event.shiftKey || event.altKey;
}
